import styled from 'styled-components';

const Main = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin-top: 80px;
  height: 100%;
  width: 100%;
`;

export default Main;
